// Which hostname is this, and where does a given path belong?
//
// The admin dashboard has its own hostname so it is not a URL a customer can
// wander into, but it is still one app in one bundle: a pushState from the
// dashboard to a marketing route would render the marketing site under
// admin.hddnlab.com, and the server's redirects never see it. These helpers are
// what make a client-side navigation cross the host boundary properly.
//
// The two names are stamped into the document by the server (api-server.js,
// buildHeadTags). When the split is off — local development, a preview
// environment, or ADMIN_HOST simply unset — the object is empty and every
// helper here degrades to "same host, plain path", which is the behaviour the
// app had before the subdomain existed.

function hosts() {
  if (typeof window === 'undefined') return {};
  return window.__HDDN_HOSTS__ || {};
}

export function adminHostActive() {
  const h = hosts();
  return !!(h.admin && h.site);
}

export function onAdminHost() {
  const h = hosts();
  return adminHostActive() && window.location.hostname.toLowerCase() === h.admin;
}

export function isAdminPath(path) {
  return path === '/admin' || path === '/admin/' || path.startsWith('/admin/');
}

// The absolute URL a path needs in order to reach the right host, or null when
// the current host is already the right one and an ordinary pushState will do.
export function crossHostUrl(href) {
  if (!adminHostActive()) return null;
  const h = hosts();
  const path = String(href || '');
  // An absolute URL is the caller's own decision about where to go.
  if (/^[a-z]+:/i.test(path) || path.startsWith('//')) return null;
  const wantsAdmin = isAdminPath(path.split('?')[0].split('#')[0]);
  const here = onAdminHost();
  if (wantsAdmin && !here) return `https://${h.admin}${path}`;
  if (!wantsAdmin && here) return `https://${h.site}${path}`;
  return null;
}

// Leaving the dashboard for the customer site, from the admin host.
export function siteUrl(path = '/') {
  const h = hosts();
  return adminHostActive() ? `https://${h.site}${path}` : path;
}

// Going the other way: reaching the dashboard from the customer site.
export function adminUrl(path = '/admin') {
  const h = hosts();
  return adminHostActive() ? `https://${h.admin}${path}` : path;
}
